import {Component, Input, OnInit} from '@angular/core';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {AmplitudeService} from '../../../../../../../application/analytics/service/amplitude.service';
import {UserContextService} from '../../../../../../../application/app-context/user-context/user-context.service';
import {UserContext} from '../../../../../../../application/app-context/user-context/user-context';
import {
  HomeAssistanceCreateRequestDialogComponent
} from '../../../../assistance/create-request-dialog/home-assistance-create-request-dialog.component';
import {DomainUrlService} from '../../../../../../../application/config/domain-url.service';
import {HomeAssistanceListDialogComponent} from '../../../../assistance/list-dialog/home-assistance-list-dialog.component';
import {SafeSubscriberDirective} from '../../../../../../../application/app-context/safe-subscriber.directive';
import {AssistanceEventService} from '../../../../../../../domain/assistance/service/assistance-event.service';
import {WidgetService} from '../../../../../../../domain/widget/service/widget.service';
import {getPlatformSolutionFromPortfolioSolution} from '../../../../../../../domain/assistance/assistance.util';
import {MatDialog} from '@angular/material/dialog';
import {Portfolio} from '../../../../../../../domain/portfolio/model/portfolio';
import {PortfolioConsultant} from '../../../../../../../domain/portfolio/model/portfolio-consultant';
import {SortByFieldPipe} from '../../../../../../pipes/sort-by-field.pipe';
import {PortfolioSolutionsEnum} from '../../../../../../../domain/core/model/portfolio-solutions.enum';

@Component({
             selector: 'app-widget-consultant-large',
             templateUrl: './home-dashboard-widget-consultant-large.component.html'
           })
export class HomeDashboardWidgetConsultantLargeComponent extends SafeSubscriberDirective implements OnInit {

  @Input() widget: WidgetDetail;
  @Input() portfolios: Array<Portfolio>;
  @Input() isMocked: boolean;

  currentPortfolio: Portfolio;
  mainPortfolioConsultant: PortfolioConsultant;
  portfolioConsultants: Array<PortfolioConsultant>;
  userContext: UserContext | undefined;
  accessValidationUrl: string;

  constructor(public ngDialog: MatDialog,
              private domainUrlService: DomainUrlService,
              private amplitudeService: AmplitudeService,
              private assistanceEventService: AssistanceEventService,
              private widgetService: WidgetService,
              private userContextService: UserContextService,
              private sortByFieldPipe: SortByFieldPipe) {
    super();
  }

  ngOnInit(): void {
    if (this.portfolios.length > 0) {
      this.initPortfolio();
    }

    this.userContext = this.userContextService.getUserContext();
    this.accessValidationUrl = this.domainUrlService.getOptimAccountUrl() + '/user-access?id=' + this.userContext.accountId;
  }

  private initPortfolio() {
    if (this.portfolios.length > 1) {
      this.portfolios = this.sortByFieldPipe.transform(this.portfolios, 'solution', Object.values(PortfolioSolutionsEnum));
    }

    this.currentPortfolio = this.portfolios[0];
    this.computePortfolioConsultant();
  }

  previousPortfolio() {
    this.currentPortfolio = this.portfolios[this.portfolios.indexOf(this.currentPortfolio) - 1];
    this.computePortfolioConsultant();
  }

  nextPortfolio() {
    this.currentPortfolio = this.portfolios[this.portfolios.indexOf(this.currentPortfolio) + 1];
    this.computePortfolioConsultant();
  }

  isLastPortfolio() {
    return this.portfolios.indexOf(this.currentPortfolio) === this.portfolios.length - 1;
  }

  isFirstPortfolio() {
    return this.portfolios.indexOf(this.currentPortfolio) === 0;
  }

  onCreateNewAssistanceRequest(): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Solution', this.currentPortfolio.solution);
    this.amplitudeService.trackEventProperties('Widget_ConsultantLarge_CreateNewSolutionAssistance', eventProperties);

    this.ngDialog.open(HomeAssistanceCreateRequestDialogComponent, {
      data: {
        solution: getPlatformSolutionFromPortfolioSolution(this.currentPortfolio.solution)
      },
      height: '100%',
      width: '400px',
      position: {
        right: '0'
      }
    });
  }

  onNavigateToAccessValidation() {
    const eventProperties = new Map<string, string>();
    this.amplitudeService.trackEventProperties('Widget_ConsultantLarge_NavigateToAccessValidation', eventProperties);
  }

  onClickOnOpenSolutionAssistancesListDialog(): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Solution', this.currentPortfolio.solution);
    this.amplitudeService.trackEventProperties('Widget_ConsultantLarge_DisplayAllListSolutionAssistances', eventProperties);

    this.ngDialog.open(HomeAssistanceListDialogComponent, {
      data: {
        selectedSolution: null
      },
      height: '100%',
      width: '75%',
      position: {
        right: '0'
      }
    });
  }

  switchMainConsultant(id: string) {
    this.mainPortfolioConsultant = this.portfolioConsultants.find(consultant => consultant.id === id);
  }

  private computePortfolioConsultant() {
    this.portfolioConsultants = this.currentPortfolio.consultants.filter(c => c.referent);

    this.mainPortfolioConsultant = this.portfolioConsultants.sort((a, b) => a.order - b.order)[0];
  }
}
